import { RESET_CREDIT_MANAGER_CONTAINER_DATA } from 'types/creditManagerContainer.constans';

export const clearCreditManager = () => ({
  type: RESET_CREDIT_MANAGER_CONTAINER_DATA,
});
